import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  methods: {
    createClip(params) {
      this.$emit("createClip", params);
    },
    deleteClip(params) {
      this.$emit("deleteClip", params);
    }
  }
});
